// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2PpH6","left":"left___1IHoJ","right":"right___1viVY"};